import { Divider, Link, Module, Space, Text } from '@billy/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { useSubscriptionLimits } from '../../../../../../hooks'
import { plansWithLimits } from '../../plansData'
import { ProgressChartComponent } from '../ProgressChartComponent'
import * as Styled from './styles'

export interface SectionPlanUsageProps {
  subscriptionPlan: SubscriptionPlan
  onClickChangePlan: () => void
}

export const SectionPlanUsageComponent = ({ onClickChangePlan, subscriptionPlan }: SectionPlanUsageProps) => {
  const { t } = useTranslation()
  const { invoices, invoicesLimit, expenses, expensesLimit, contacts, contactsLimit } = useSubscriptionLimits()
  const isPremium = subscriptionPlan === SubscriptionPlan.Premium
  const isLimitedPlan = plansWithLimits.includes(subscriptionPlan)

  const shouldShowInvoicesData = !!invoicesLimit
  const shouldShowExpensesData = !!expensesLimit
  const shouldShowContactsData = !!contactsLimit
  const shouldShowAnyData = shouldShowInvoicesData || shouldShowExpensesData || shouldShowContactsData

  if (!shouldShowAnyData) {
    return null
  }

  return (
    <>
      <Space size="s16" />
      <Divider />
      <Space size="s16" />
      <Module.Section title={t('organization_subscription.plan_usage')}>
        <Styled.UsageUpsellWrapper>
          <Styled.UsageWrapper>
            {shouldShowContactsData && (
              <ProgressChartComponent
                leftLabel={t('organization_subscription.contacts')}
                rightLabel={`${contacts}/${contactsLimit}`}
                value={contacts || 0}
                total={contactsLimit || 0}
              />
            )}
            {shouldShowInvoicesData && (
              <ProgressChartComponent
                leftLabel={t('organization_subscription.invoices')}
                rightLabel={`${invoices}/${invoicesLimit}`}
                value={invoices || 0}
                total={invoicesLimit || 0}
              />
            )}
            {shouldShowExpensesData && (
              <ProgressChartComponent
                leftLabel={t('organization_subscription.expenses')}
                rightLabel={`${expenses}/${expensesLimit}`}
                value={expenses || 0}
                total={expensesLimit || 0}
              />
            )}
          </Styled.UsageWrapper>
          <Styled.UpsellWrapper>
            <Styled.UpsellText flexible={isPremium}>
              {isPremium ? (
                <Styled.NoLimitationsText variant="bodySM" colorVariant="secondary">
                  <span role="img" aria-label="Tada!">
                    🎉
                  </span>
                  {t('organization_subscription.no_limitations')}
                </Styled.NoLimitationsText>
              ) : null}

              {isLimitedPlan ? (
                <>
                  <Text variant="bodySM" inline>
                    <Link underlined withAnimation onClick={onClickChangePlan}>
                      {t('organization_subscription.upgrade_your_plan')}{' '}
                    </Link>
                  </Text>
                  <Text variant="bodySM" inline>
                    {t('organization_subscription.upgrade_your_plan.to_prevent')}
                  </Text>
                </>
              ) : null}
            </Styled.UpsellText>
          </Styled.UpsellWrapper>
        </Styled.UsageUpsellWrapper>
      </Module.Section>
    </>
  )
}
